
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

import { mdiArrowLeft, mdiArrowRight } from "@mdi/js";

import SpLocation from "~/components/v2/splash/sp-location.vue";

export default {
  components: { VueSlickCarousel, SpLocation },
  data() {
    return {
      mdiArrowLeft,
      mdiArrowRight,

      settings: {
        dots: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        touchThreshold: 5,
        arrows: true,
        draggable: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              dots: false,
              centerPadding: "72px",
            },
          },
        ],
      },
    };
  },

  computed: {
    locations() {
      return this.$store.getters["sliders/getLocationSlider"];
    },
  },
};
